import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["user.lineUserForm"],
  form => form
);
